/* eslint-disable import/max-dependencies */
import React from "react";
import { Helmet } from "react-helmet";
import {
  Grid,
  Container,
  Box,
} from "@mui/material";
import LinkingListContainer from "../../components/LinkingList";
import { mainBackgroundStyles } from "../../styles/common";

function LinkingList() {
  return (
    <>
      <Helmet>
        <title>Linking List</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        sx={mainBackgroundStyles}
      >
        <Container maxWidth={false}>
          <Box mt={3} mb={3}>
            <LinkingListContainer />
          </Box>
        </Container>
      </Grid>
    </>
  );
}

export default LinkingList;
